import {css} from 'lit'; export default css`.bulk-action{display:flex;align-items:center;gap:12px}.bulk-action__ok{margin-bottom:36px}`;
    